// Creation drafts and templates use the same rule as the metric editor:
// only Number metrics can accumulate values. Return a copy so normalizing an
// editor view or submission never mutates a saved template.
export function normalizeMetricUpdateBehaviors(schema) {
  return Object.fromEntries(Object.entries(schema || {}).map(([name, config]) => {
    if (!config || typeof config !== 'object' || Array.isArray(config)) {
      return [name, config];
    }
    if (Object.prototype.hasOwnProperty.call(config, 'type')) {
      return [name, {
        ...config,
        updateBehavior: config.type === 'Number'
          ? (config.updateBehavior ?? 'Overwrite')
          : 'Overwrite',
      }];
    }
    return [name, normalizeMetricUpdateBehaviors(config)];
  }));
}
